module.exports = __webpack_public_path__ + "img/coding.0db31681.jpg";